export { default as VideoPlayer } from './component';
